import QueuePage from "./QueuePage";
export default function Verifikasi() {
  return <QueuePage status="DIAJUKAN" title="Antrean Verifikasi" description="Klaim yang menunggu verifikasi awal." testId="verifikasi-page" />;
}
